// Replacement for next/navigation's usePathname.
import { useLocation } from "react-router-dom";

export function usePathname() {
  return useLocation().pathname;
}
